import { BasePage } from '@Tenants/Hc/Site/BasePage';
import { BaseTransitTimes } from '@Base/TransitTimes/TransitTimes';

export class TransitTimes extends BaseTransitTimes
{
	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
	}
}

export class TransitTimesPage extends BasePage
{
	public TransitTimes: TransitTimes;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.TransitTimes = new TransitTimes();
	}
}

const transitTimes = new TransitTimesPage();